<ng-container>
    <motors-tabs selectedStepId="selectedStepId" (beforeStepChange)="beforeStepChange($event.cb, $event.arg, $event.isBack)"></motors-tabs>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
    <tg-rack *ngIf="isStepInfoReady && isFooterVisible">
        <tg-rack-item class="motors-home-page__footer-container--large-margin">
            <tg-rack-item-primary>
                <motors-footer
                    (continue)="onContinue($event)"
                    (createListing)="onCreateListing($event)"
                    (saveAndExit)="onSaveAndExit()"
                    (topUpCompleted)="onTopUpCompleted()"
                    (editListing)="onEditListing()"
                    (relistListing)="onRelistListing()">
                </motors-footer>
            </tg-rack-item-primary>
        </tg-rack-item>
    </tg-rack>
</ng-container>
<div class="motors-home-page__feedback-email-button-container l-container">
    <tm-feedback-email-button class="motors-home-page__feedback-email-button"></tm-feedback-email-button>
</div>
